// Types are inferred from Zod schemas — single source of truth.
// See ../schemas/index.ts for runtime validation.
// Display labels for UI — pure data, no logic.
export const FORMAT_LABELS = {
    standard: 'Standard',
    pioneer: 'Pioneer',
    modern: 'Modern',
    historic: 'Historic',
    explorer: 'Explorer',
    alchemy: 'Alchemy',
    brawl: 'Brawl',
    timeless: 'Timeless',
    limited: 'Limited',
    pauper: 'Pauper',
    legacy: 'Legacy',
    vintage: 'Vintage',
    commander: 'Commander',
};
export const COLOR_LABELS = {
    W: { name: 'White', symbol: '☀', hue: 50 },
    U: { name: 'Blue', symbol: '💧', hue: 220 },
    B: { name: 'Black', symbol: '☠', hue: 285 },
    R: { name: 'Red', symbol: '🔥', hue: 10 },
    G: { name: 'Green', symbol: '🌿', hue: 130 },
    C: { name: 'Colorless', symbol: '◇', hue: 0 },
};
//# sourceMappingURL=index.js.map